import utils from "./utils";

const basePath = utils.getEdgeBasePath();

async function parseJsonResponse(response) {
  const data = await response.json();
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.message || data?.error || "Request failed");
  }
  return data;
}

export async function fetchUiExperimentStatus() {
  const response = await fetch(`${basePath}/api/v1/ui-experiments/v2/status`, {
    credentials: "include",
  });
  return parseJsonResponse(response);
}

export async function respondToUiExperimentPrompt(response) {
  const res = await fetch(`${basePath}/api/v1/ui-experiments/v2/respond`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ response }),
  });
  return parseJsonResponse(res);
}

export async function switchUiDesignLane(lane) {
  const res = await fetch(`${basePath}/api/v1/ui-experiments/v2/switch`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ lane }),
  });
  return parseJsonResponse(res);
}

export async function recordUiExperimentPromptShown(meta = {}) {
  const res = await fetch(`${basePath}/api/v1/ui-experiments/v2/prompt-shown`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ meta }),
  });
  return parseJsonResponse(res);
}
